var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonViewFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.75C17.0711 18.75 18.75 17.0711 18.75 15C18.75 12.9289 17.0711 11.25 15 11.25C12.9289 11.25 11.25 12.9289 11.25 15C11.25 17.0711 12.9289 18.75 15 18.75Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0059 14.6812C27.9032 11.829 25.989 9.36245 23.4997 7.58633C21.0105 5.81021 18.0554 4.80241 14.9996 4.6875C11.9438 4.80241 8.98872 5.81021 6.49948 7.58633C4.01024 9.36245 2.096 11.829 0.993351 14.6812C0.918883 14.8872 0.918883 15.1128 0.993351 15.3188C2.096 18.171 4.01024 20.6375 6.49948 22.4137C8.98872 24.1898 11.9438 25.1976 14.9996 25.3125C18.0554 25.1976 21.0105 24.1898 23.4997 22.4137C25.989 20.6375 27.9032 18.171 29.0059 15.3188C29.0803 15.1128 29.0803 14.8872 29.0059 14.6812ZM14.9996 21.0938C13.7944 21.0938 12.6162 20.7364 11.6141 20.0668C10.612 19.3972 9.83093 18.4455 9.36971 17.332C8.90849 16.2185 8.78781 14.9932 9.02294 13.8112C9.25807 12.6291 9.83844 11.5433 10.6907 10.6911C11.5429 9.83884 12.6287 9.25847 13.8108 9.02334C14.9928 8.78821 16.2181 8.90889 17.3316 9.37011C18.4451 9.83133 19.3968 10.6124 20.0664 11.6145C20.736 12.6166 21.0934 13.7948 21.0934 15C21.0909 16.6154 20.4481 18.1639 19.3058 19.3062C18.1635 20.4485 16.615 21.0913 14.9996 21.0938Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonViewFilled);
export default __webpack_public_path__ + "static/media/carbon_view-filled.0453a4a4.svg";
export { ForwardRef as ReactComponent };